import React from 'react'

export default function MainWrapper(props) {
    return (
        <div style={{padding:'40px'}}>{props.children}</div>
    )
}
